export default __webpack_public_path__ + "static/media/tahoe_id.c2c3f2fd.csv";